import type {
  ModalMutualFriendsOptInStepIndex,
  ModalMutualFriendsOptInStepName,
} from 'Store/mutualFriends/types';

// Action types
export const CONTACT_PICKER_PERMISSION_GRANTED = 'CONTACT_PICKER_PERMISSION_GRANTED';
export const CONTACT_PICKER_PERMISSION_RESET = 'CONTACT_PICKER_PERMISSION_RESET';
export const MUTUAL_FRIENDS_IMPORT = 'MUTUAL_FRIENDS_IMPORT';
export const MUTUAL_FRIENDS_LOADING = 'MUTUAL_FRIENDS_LOADING';
export const MUTUAL_FRIENDS_OPT_OUT = 'MUTUAL_FRIENDS_OPT_OUT';
export const MUTUAL_FRIENDS_RESET_STEP = 'MUTUAL_FRIENDS_RESET_STEP';
export const MUTUAL_FRIENDS_SET_STEP = 'MUTUAL_FRIENDS_SET_STEP';
export const MUTUAL_FRIENDS_TUTORIAL_VIEWED = 'MUTUAL_FRIENDS_TUTORIAL_VIEWED';

// Copy IDs
export const NOTIFICATION_BLOCK_SUCCESSFUL_COPY_ID =
  'The contacts you selected were added to your blocked list.';
/* Copy IDs */

// Lever Values
export const LEVER_FRIENDS_OF_FRIENDS_VARIANT_ENABLED = 1;

// Notifications - Permissions
export const NOTIFICATION_CONTACT_PICKER_PERMISSION_DENIED_COPY_ID =
  'Please grant access to contacts when prompted to proceed.';

// Notifications - Contact Import
export const NOTIFICATION_IMPORT_COMPLETE_COPY_ID = 'Contacts Uploaded';
export const NOTIFICATION_IMPORT_CONTACTLESS_COPY_ID =
  'No contacts were found. Please select at least one valid contact.';
export const NOTIFICATION_IMPORT_FAILED_COPY_ID = 'Contact upload failed';
export const NOTIFICATION_IMPORT_IN_PROGRESS_COPY_ID = 'Contacts are uploading';

// Notifications - Opt Out
export const NOTIFICATION_OPT_OUT_FAILED_COPY_ID = 'Failed to opt out. Please retry.';
export const NOTIFICATION_OPT_OUT_SUCCESSFUL_COPY_ID = 'Successfully opted out.';

// Opt in modal steps
export const MUTUAL_FRIENDS_OPT_IN_STEP_CONFIRMATION = 'CONFIRMATION';
export const MUTUAL_FRIENDS_OPT_IN_STEP_IMPORT = 'IMPORT';
export const MUTUAL_FRIENDS_OPT_IN_STEP_INFO = 'INFO';
export const MUTUAL_FRIENDS_OPT_IN_STEP_INTRO = 'INTRO';

export const MODAL_MUTUAL_FRIENDS_OPT_IN_STEPS: Record<
  ModalMutualFriendsOptInStepName,
  ModalMutualFriendsOptInStepIndex
> = {
  [MUTUAL_FRIENDS_OPT_IN_STEP_INTRO]: 0,
  [MUTUAL_FRIENDS_OPT_IN_STEP_INFO]: 1,
  [MUTUAL_FRIENDS_OPT_IN_STEP_IMPORT]: 2,
  [MUTUAL_FRIENDS_OPT_IN_STEP_CONFIRMATION]: 3,
};

export const MUTUAL_FRIENDS_MODAL_STEP_COUNT = Object.keys(
  MODAL_MUTUAL_FRIENDS_OPT_IN_STEPS
).length;

export const MODAL_MUTUAL_FRIENDS_OPT_IN_INITIAL_STEP: (typeof MODAL_MUTUAL_FRIENDS_OPT_IN_STEPS)['INTRO'] =
  MODAL_MUTUAL_FRIENDS_OPT_IN_STEPS.INTRO;
